import { PremiumFeature } from '../proto/generated/subscription'

export const hasFeatureAccess = (
    premiumFeatures: PremiumFeature[] | undefined,
    userFeatures: PremiumFeature[] | undefined,
    category: string,
    subCategory?: string,
    feature?: string
): boolean => {
    const matches = (f: PremiumFeature) =>
        f.category?.toUpperCase() === category.toUpperCase() &&
        (!subCategory || f.subCategory?.toUpperCase() === subCategory.toUpperCase()) &&
        (!feature || f.feature?.toUpperCase() === feature.toUpperCase())

    const isPremium = premiumFeatures?.some(matches) ?? false
    const userHasFeature = userFeatures?.some(matches) ?? false
    if (isPremium && !userHasFeature) {
        return false
    }
    return true
}
